// always show floating label when something is selected
$('.bootstrap-select:has(select:has(:first-child:not(:checked)))~label').addClass('placeholder-label');

/**
 * Check if the floating label has to be shown
 *
 * @param {HTMLSelectElement} select
 */
const updateFloatingLabelOfSelect = (select) => {
    const formGroup = select.closest('.form-group');
    const floatingLabel = formGroup ? formGroup.querySelector('.form-control-label') : null;

    let addPlaceholderClass = false;
    const selectedOptions = select.options;

    if (selectedOptions.length) {
        Array.from(selectedOptions).every((option) => {
            if (
                option.selected
                && option.value
                && option.value !== ''
                && !option.classList.contains('bs-title-option')
                && floatingLabel
            ) {
                addPlaceholderClass = true;
                return false; // break the loop
            }
            return true; // continues the loop, this is required
        });
    }

    if (addPlaceholderClass) {
        floatingLabel.classList.add('placeholder-label');
    }
    else {
        floatingLabel.classList.remove('placeholder-label');
    }
};

(function (window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        /** @type {NodeListOf<HTMLSelectElement>} */
        const selectElements = document.querySelectorAll('.selectpicker');

        if (selectElements.length) {
            Array.from(selectElements).forEach((select) => {
                select.addEventListener('change', () => {
                    updateFloatingLabelOfSelect(select);
                });
                updateFloatingLabelOfSelect(select);
            });
        }
    });
})(window, document, window.PageLoadedQueue);
